/* eslint-disable import/prefer-default-export */
export const LOCATION_TYPE = {
  COLLECTION: 1,
  DELIVERY: 2,
  AGGREGATION: 3,
  HUB_STATION: 4,
};
